import ShowcaseCollectionCard from './ShowcaseCollectionCard';

export default ShowcaseCollectionCard;
